import React, { useEffect, useState } from "react";
import _ from "lodash";

import { useDispatch } from "Hooks/useDispatch";
import { setSamlInitiatedDetails } from "Login/modules/LoginModule";

const SamlIdpResponseScreen = ({ samlInitiatedDetails }) => {
  const dispatch = useDispatch();
  const isInitiated = _.get(samlInitiatedDetails, "isInitiated", false);
  const redirectUrl = _.get(samlInitiatedDetails, "redirectUrl", "");
  const samlResponse = _.get(samlInitiatedDetails, "samlResponse", "");
  const relayState = _.get(samlInitiatedDetails, "relayState", "");
  const openInNewTab = _.get(samlInitiatedDetails, "openInNewTab", false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitForm = () => {
    setIsSubmitting(true);

    const form = document.createElement("form");
    form.method = "POST";
    form.action = redirectUrl;

    if (openInNewTab) {
      form.target = "_blank";
    }

    const samlInput = document.createElement("input");
    samlInput.type = "hidden";
    samlInput.name = "SAMLResponse";
    samlInput.value = samlResponse;

    const relayInput = document.createElement("input");
    relayInput.type = "hidden";
    relayInput.name = "RelayState";
    relayInput.value = relayState;

    form.appendChild(samlInput);
    form.appendChild(relayInput);

    document.body.appendChild(form);
    form.submit();

    // Cleanup form after submission
    setTimeout(() => {
      if (document.body.contains(form)) {
        document.body.removeChild(form);
      }
      dispatch(
        setSamlInitiatedDetails({
          redirectUrl: "",
          samlResponse: "",
          relayState: "",
          isInitiated: false,
          openInNewTab: false,
        })
      );
    }, 100);
  };

  useEffect(() => {
    if (!isInitiated || isSubmitting) return;

    if (_.isEmpty(redirectUrl) || _.isEmpty(samlResponse)) {
      return;
    }

    submitForm();
  }, [isInitiated, redirectUrl, samlResponse, relayState, isSubmitting]);

  return null;
};

export default SamlIdpResponseScreen;
